import { render, staticRenderFns } from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=template&id=223f47c6&scoped=true&lang=pug"
import script from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=script&lang=js"
export * from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=script&lang=js"
import style0 from "./ModalDiagnosticoSociambientalEmLote.vue?vue&type=style&index=0&id=223f47c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f47c6",
  null
  
)

export default component.exports